/* Pikalo DE – busy book. Fiche produit, coffrets, menu. Sélecteur de sets, tiroir panier, cadeaux et garantie : Moonbundle (ancien sélecteur et ancien tiroir retirés le 04/11). */
(function () {
  'use strict';
  var BB = window.BB || (window.BB = {});
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function eur(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  BB.eur = eur;
  var ERR = 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.';

  /* ---------------- Panier (tiroir Moonbundle) ---------------- */
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  /* Compteur de l'en-tête : articles payants seulement (cadeaux et garantie à 0 € exclus) */
  function count(cart) {
    var n = 0;
    (cart.items || []).forEach(function (i) { if (i.original_price > 0) n += i.quantity; });
    qa('[data-bb-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    return cart;
  }
  function refreshCount() { return getCart().then(count).catch(function () {}); }
  function mbOpen() {
    var d = q('#moonbundle-cart-drawer');
    return !!(d && window.getComputedStyle(d).visibility === 'visible');
  }
  function openCart() {
    if (typeof window.openMoonBundleCartDrawer === 'function' && q('moonbundle-cart-drawer-block')) window.openMoonBundleCartDrawer();
    else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  }
  /* Ajout au panier : Moonbundle intercepte /cart/add.js (set, Duo, cadeaux, garantie) et ouvre son tiroir */
  BB.add = function (items) {
    return post('/cart/add.js', { items: items }).then(function (d) {
      window.setTimeout(function () { refreshCount(); if (!mbOpen()) openCart(); }, 1200);
      return d;
    });
  };
  BB.openCart = openCart;

  /* ---------------- Fiche produit ---------------- */
  function initPP() {
    var R = q('[data-bb-pp]'); if (!R) return;
    var D; try { D = JSON.parse(q('[data-bb-pp-data]', R).textContent); } catch (e) { return; }
    var errEl = q('[data-bb-err]', R);
    /* Variante envoyée au panier : Moonbundle la remplace par le set, la couleur et le Duo choisis dans son bloc */
    function V() { for (var i = 0; i < D.variants.length; i++) { var v = D.variants[i]; if (v.set === D.defaultSet && v.color === D.defaultColor) return v; } return D.variants[0]; }
    qa('[data-bb-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = V(); if (!v) return;
        btn.disabled = true;
        if (errEl) errEl.hidden = true;
        BB.add([{ id: v.id, quantity: 1 }]).catch(function (e) {
          if (errEl) { errEl.textContent = ERR; errEl.hidden = false; }
          if (window.console) console.warn('[bb] cart/add', e);
        }).then(function () { btn.disabled = false; });
      });
    });
    /* Galerie : compteur + vignettes */
    var tr = q('[data-bb-track]', R), cnt = q('[data-bb-gal-count]', R), th = qa('[data-bb-thumb]', R);
    if (tr) {
      var slides = qa('.bb-gal__slide', tr);
      var onScroll = function () {
        var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
        [i + 1, i + 2].forEach(function (n) { var im = slides[n] && slides[n].querySelector('img'); if (im) im.loading = 'eager'; });
        if (cnt) cnt.textContent = (i + 1) + ' / ' + slides.length;
        th.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      };
      tr.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
      th.forEach(function (b, n) { b.addEventListener('click', function () { tr.scrollTo({ left: slides[n].offsetLeft - tr.offsetLeft, behavior: 'smooth' }); }); });
      onScroll();
    }
    /* Barre collante : visible tant que le bouton principal n'est pas à l'écran */
    var sticky = q('[data-bb-sticky]'), main = q('[data-bb-atc-main]', R);
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting); }).observe(main);
    }
  }

  /* ---------------- Upsell coffrets ---------------- */
  function initUps() {
    var U = q('[data-bb-ups]'); if (!U) return;
    var color = 'Blau';
    qa('[data-bb-ucolor]', U).forEach(function (b) {
      b.addEventListener('click', function () {
        color = b.getAttribute('data-bb-ucolor');
        qa('[data-bb-ucolor]', U).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      });
    });
    qa('[data-bb-up]', U).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute(color === 'Rosa' ? 'data-rosa' : 'data-blau'); if (!id) return;
        btn.disabled = true;
        var err = q('[data-bb-up-err]', btn.parentNode);
        BB.add([{ id: Number(id), quantity: 1 }]).catch(function (e) {
          if (err) { err.textContent = ERR; err.hidden = false; }
          if (window.console) console.warn('[bb] cart/add', e);
        }).then(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------------- Divers ---------------- */
  function initMisc() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentNode;
      var el;
      if ((el = t.closest('[data-bb-cart-open]'))) { e.preventDefault(); BB.openCart(); return; }
      if ((el = t.closest('[data-bb-menu]'))) { var m = q('[data-bb-menu-panel]'); m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); return; }
      if ((el = t.closest('[data-bb-menu-close]'))) { var m2 = q('[data-bb-menu-panel]'); m2.classList.remove('is-open'); m2.setAttribute('aria-hidden', 'true'); return; }
      if ((el = t.closest('[data-bb-search]'))) { var s = q('[data-bb-search-bar]'); s.classList.toggle('is-open'); if (s.classList.contains('is-open')) { var i = q('input[type=search]', s); if (i) i.focus(); } return; }
      if ((el = t.closest('[data-bb-go]'))) {
        var target = q(el.getAttribute('data-bb-go'));
        if (target) {
          e.preventDefault();
          var pick = el.getAttribute('data-bb-pick');
          if (pick) document.dispatchEvent(new CustomEvent('bb:pick', { detail: pick }));
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      if ((el = t.closest('[data-bb-more]'))) { var w = el.parentNode.querySelector('.bb-revs'); if (w) w.classList.add('is-all'); el.hidden = true; return; }
      if ((el = t.closest('[data-bb-cookies]'))) {
        if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
        return;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var m = q('[data-bb-menu-panel]'); if (m) m.classList.remove('is-open'); } });
    /* Suivi de colis (page Sendungsverfolgung) */
    qa('[data-bb-track]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = f.querySelector('input').value.trim(), er = f.querySelector('[data-bb-track-err]');
        if (!v) { if (er) er.hidden = false; return; }
        if (er) er.hidden = true;
        window.open('https://t.17track.net/de#nums=' + encodeURIComponent(v), '_blank', 'noopener');
      });
    });
    refreshCount();
    /* Le compteur suit aussi les changements faits dans le tiroir Moonbundle */
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCount(); });
    window.addEventListener('moonbundle-cart-updated', function () { window.setTimeout(refreshCount, 800); });
    document.addEventListener('cart:close', refreshCount);
  }

  function boot() { initMisc(); initPP(); initUps(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
